import classNames from 'classnames';

// images
import Preloader from './images/preloader.gif';

// styles
import s from './RouterPreloader.sss';

// types
type RouterPreloaderProps = {
  className?: string;
};

export const RouterPreloader: React.FC<RouterPreloaderProps> = ({
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <img className={s.image} src={Preloader} alt="preloader" />
  </div>
);

export default RouterPreloader;
